import React from "react";
import { PeekTypography, PeekChip, useTheme } from "@piiqtechnologies/ui-components";
export var STATUS_VALUES;
(function (STATUS_VALUES) {
    STATUS_VALUES["PRIORITY_FIX"] = "Priority Fix";
    STATUS_VALUES["MAINTAIN"] = "Maintain";
    STATUS_VALUES["MONITOR"] = "Monitor";
    STATUS_VALUES["IMPROVE"] = "Improve";
})(STATUS_VALUES || (STATUS_VALUES = {}));
var STATUS_COLORS;
(function (STATUS_COLORS) {
    STATUS_COLORS["PRIORITY_FIX"] = "error";
    STATUS_COLORS["MAINTAIN"] = "success";
    STATUS_COLORS["MONITOR"] = "blue";
    STATUS_COLORS["IMPROVE"] = "warning";
})(STATUS_COLORS || (STATUS_COLORS = {}));
export const StatusChip = ({ status }) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    if (!status)
        return React.createElement(PeekTypography, { color: theme.palette.grey[400] }, "\u2013");
    const colorVariant = STATUS_COLORS[status.toUpperCase()];
    return (React.createElement(PeekChip, { size: "small", sx: {
            color: ((_a = theme.palette[colorVariant]) === null || _a === void 0 ? void 0 : _a.main) || ((_b = theme.palette[colorVariant]) === null || _b === void 0 ? void 0 : _b[500]),
            "&.MuiChip-filledDefault": {
                backgroundColor: ((_c = theme.palette[colorVariant]) === null || _c === void 0 ? void 0 : _c.light) || ((_d = theme.palette[colorVariant]) === null || _d === void 0 ? void 0 : _d[200]),
            },
        }, variant: "filled", label: STATUS_VALUES[status.toUpperCase()] }));
};
export default StatusChip;
